import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/no-data-icon.svg'


const _hoisted_1 = { class: "v-table-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "checkbox-cell"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "sort-icon"
}
const _hoisted_5 = ["data-key"]
const _hoisted_6 = {
  key: 0,
  class: "checkbox-cell"
}
const _hoisted_7 = {
  key: 0,
  style: {"height":"130px"}
}
const _hoisted_8 = {
  key: 0,
  class: "v-table__alt-header"
}
const _hoisted_9 = { class: "v-table__alt-header-count" }
const _hoisted_10 = {
  key: 1,
  class: "v-table__fixed-content"
}
const _hoisted_11 = {
  key: 0,
  class: "v-table__preloader"
}
const _hoisted_12 = {
  key: 1,
  class: "v-table__no-data"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "No Data",
  height: "35"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "No Data", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "v-table__fixed-column" }
const _hoisted_17 = ["data-key"]

import { computed, reactive, ref, shallowRef, watch } from 'vue';
import { num } from '@/utils/lang'
import VCheckbox from './VCheckbox.vue'
import SortIcon from './icons/navigation/SortIcon.vue';
import SortDescIcon from './icons/navigation/SortDescIcon.vue';
import DownArrowIcon from './icons/navigation/DownArrowIcon.vue';
import { useContextMenuStore } from '@/stores/context-menu';
import VLoader from '@/components/VLoader.vue'
import { useResizeObserver, useScroll } from '@vueuse/core';

type Column = {
  title?: string,
  fallback?: string,
  width?: number,
  minWidth?: number,
  sort?: boolean,
  get?: (value: string) => any,
  class?: string,
  filters?: { title: string, filter: (item: any) => boolean }[],
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Table',
  props: {
    columns: null,
    data: null,
    rowKey: null,
    checkable: { type: Boolean },
    search: null,
    searchField: null,
    socialFilter: null,
    modelValue: null,
    defaultSort: null,
    loading: { type: Boolean },
    hideStub: { type: Boolean },
    enabledKey: null,
    sort: null,
    disableInnerSort: { type: Boolean }
  },
  emits: [ "update:sort" ],
  setup(__props: any, { emit }) {

const props = __props as { 
  columns: { [ key: string ]: Column },
  data: Array<any>,
  rowKey?: string,
  checkable?: boolean,
  search?: string,
  searchField?: string,
  socialFilter?: string | null,
  modelValue?: Set<any>,
  defaultSort?: string,
  loading?: boolean,
  hideStub?: boolean,
  enabledKey?: string,
  sort?: string,
  disableInnerSort?: boolean
}





const firstColumn = computed(() => {
  return Object.values(props.columns)[0]
})
const firstColumnKey = computed(() => {
  return Object.keys(props.columns)[0]
})

const checked = props.modelValue || reactive(new Set( props.modelValue ))

const mainCheckbox = computed({
  get() {
    return checked.size > 0
  },
  set() {
    if (checked.size > 0) {
      checked.clear()
    } else {
      for (let i = 0; i < props.data.length; i++) {
        checked.add(props.data[i])
      }
    }
  }
})

const getClass = (item: any, index: number) => ({
  checked: checked.has(item), 
  linted: index%2 === 1, 
  disabled: props.enabledKey && (item[props.enabledKey] === false || item[props.enabledKey] === 'false')
})

const getKey = (item: any, index: number) => { 
  return props.rowKey? item[props.rowKey]: index
}

const getColumnValue = (column: Column, columnKey: string | number, item: any) => {
  if (!item) return ""
  return column.get? column.get(item): item[columnKey]
}

const contextMenuStore = useContextMenuStore()
const sortColumn = ref<{ key: string, order: "asc" | "desc"} | null>(null)
watch(sortColumn, (value) => {
  if (!value) {
    emit("update:sort", null)
  } else {
    emit("update:sort", value.order === "asc"? value.key: ("-"+value.key))
  }
})
if (props.defaultSort) {
  sortColumn.value = { key: props.defaultSort, order: "desc" }
}
const filter = shallowRef<((item: any) => boolean) | null>(null)
const onColumnClick = (column: Column, key: string, e: MouseEvent) => {
  if (column.sort) {
    if (sortColumn.value?.key === key) {
      if (sortColumn.value.order === "desc") {
        sortColumn.value = { key, order: "asc" }
      } else {
        sortColumn.value = null
      }
    } else {
      sortColumn.value = { key, order: "desc" }
    }
  }
  if (column.filters) {
    const items = column.filters.map(item => ({ 
      title: item.title, 
      selected: filter.value === item.filter,
      onClick: () => { filter.value = item.filter } 
    }))
    items.unshift({ 
      title: "Show all", 
      selected: !column.filters.find(item => item.filter === filter.value),
      onClick: () => { filter.value = null } 
    })
    contextMenuStore.openEl(e, items, { offsetY: -14 })
  }
}

const sortedData = computed(() => {
  let arr = props.data
  if (filter.value) {
    arr = arr.filter(item => filter.value!(item))
  } else {
    arr = arr.slice()
  }
  if (sortColumn.value && !props.disableInnerSort) {
    const { key, order } = sortColumn.value
    const column = props.columns[key]
    arr = arr.sort((a: any, b): any => {
      const valA = parseInt(column.get ? column.get(a) : a[key], 10);
      const valB = parseInt(column.get ? column.get(b) : b[key], 10);

      if (valA === valB) return 0;
      return (valA > valB ? 1 : -1) * (order === "asc" ? 1 : -1);
    });
  }
  if (props.socialFilter) {
    arr = arr.filter(item => (props.socialFilter === "fb" && item.type_id === 1) || (props.socialFilter === "ig" && item.type_id === 2) || (props.socialFilter === "tiktok" && item.type_id === 3)) 
  }
  if (props.search) {
    const val = props.search.toLowerCase()
    arr = arr.filter(item => item[props.searchField ?? "name"].toLowerCase().includes(val))
  }
  return arr
})

const tableRef = ref<HTMLTableElement>()
const rowSizes = reactive<number[]>([])
const recalcRowSizes = () => {
  if (!tableRef.value) return
  rowSizes.length = 0
  rowSizes.push(tableRef.value.children[0].children[0].clientHeight+0.5)

  let size = 0
  for (let child of tableRef.value.children[1].children) {
    size += child.clientHeight
    rowSizes.push(child.clientHeight)
  }
  const k = tableRef.value.children[1].clientHeight / size
  for (let i = 1; i < rowSizes.length; i++) {
    rowSizes[i] = rowSizes[i] * k
  }
}
useResizeObserver(tableRef, recalcRowSizes)
watch(sortedData, recalcRowSizes, { deep: true, flush: "post" })

const parentRef = ref<HTMLDivElement>()
const { x: scrollX } = useScroll(parentRef)
const showFixedColumn = computed(() => scrollX.value > 100)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "parentRef",
      ref: parentRef,
      class: "scroll-content"
    }, [
      _createElementVNode("table", {
        ref_key: "tableRef",
        ref: tableRef,
        class: _normalizeClass(["v-table", { multiselect: _unref(checked).size > 0 }])
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", {
            class: _normalizeClass({ 'row-hide': _unref(checked).size > 0 })
          }, [
            (props.checkable)
              ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
                  _createVNode(VCheckbox, {
                    modelValue: _unref(mainCheckbox),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(mainCheckbox) ? (mainCheckbox).value = $event : null)),
                    alt: _unref(checked).size < props.data.length
                  }, null, 8, ["modelValue", "alt"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, key) => {
              return (_openBlock(), _createElementBlock("th", {
                key: key,
                class: _normalizeClass({ clickable: column.sort || column.filters }),
                style: _normalizeStyle({ width: column.width && column.width +'px','min-width': column.minWidth && column.minWidth +'px' }),
                onClick: ($event: any) => (onColumnClick(column, key as string, $event))
              }, [
                _createTextVNode(_toDisplayString(column.title ?? key) + " ", 1),
                (column.sort)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["sort-icon", { sorted: sortColumn.value?.key === key }])
                    }, [
                      (sortColumn.value?.key === key)
                        ? (_openBlock(), _createBlock(SortDescIcon, {
                            key: 0,
                            class: _normalizeClass({ desc: sortColumn.value.order === 'desc' })
                          }, null, 8, ["class"]))
                        : (_openBlock(), _createBlock(SortIcon, { key: 1 }))
                    ], 2))
                  : _createCommentVNode("", true),
                (column.filters)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(DownArrowIcon)
                    ]))
                  : _createCommentVNode("", true)
              ], 14, _hoisted_3))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedData), (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              "data-key": getKey(item, index),
              key: getKey(item, index),
              class: _normalizeClass(getClass(item, index))
            }, [
              (props.checkable)
                ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                    _createVNode(VCheckbox, {
                      modelValue: _unref(checked),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null)),
                      value: item
                    }, null, 8, ["modelValue", "value"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, key, columnIndex) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: _normalizeClass(column.class),
                  key: key
                }, [
                  _renderSlot(_ctx.$slots, key, {
                    item: item,
                    cell: getColumnValue(column, key, item)
                  }, () => [
                    _createTextVNode(_toDisplayString(getColumnValue(column, key, item) ?? column.fallback), 1)
                  ])
                ], 2))
              }), 128))
            ], 10, _hoisted_5))
          }), 128))
        ])
      ], 2),
      (!props.hideStub && props.data.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("", true)
    ], 512),
    (_unref(checked).size > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(VCheckbox, {
            modelValue: _unref(mainCheckbox),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(mainCheckbox) ? (mainCheckbox).value = $event : null)),
            alt: _unref(checked).size < props.data.length
          }, null, 8, ["modelValue", "alt"]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(num)(_unref(checked).size, "item selected", "items selected")), 1),
          _renderSlot(_ctx.$slots, "alt-header")
        ]))
      : _createCommentVNode("", true),
    (!props.hideStub && props.data.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(VLoader)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        ]))
      : _createCommentVNode("", true),
    (props.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["v-table__fixed-column-wrapper", { hidden: !_unref(showFixedColumn) }])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              style: _normalizeStyle({ height: rowSizes[0] + 'px' }),
              class: "th"
            }, [
              (props.checkable)
                ? (_openBlock(), _createBlock(VCheckbox, {
                    key: 0,
                    modelValue: _unref(mainCheckbox),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(mainCheckbox) ? (mainCheckbox).value = $event : null)),
                    alt: _unref(checked).size < props.data.length
                  }, null, 8, ["modelValue", "alt"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_unref(firstColumn).title), 1)
            ], 4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedData), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                "data-key": getKey(item, index),
                key: getKey(item, index),
                class: _normalizeClass(getClass(item, index)),
                style: _normalizeStyle({ height: rowSizes[index+1]? rowSizes[index+1] + 'px': undefined })
              }, [
                (props.checkable)
                  ? (_openBlock(), _createBlock(VCheckbox, {
                      key: 0,
                      modelValue: _unref(checked),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(checked) ? (checked).value = $event : null)),
                      value: item
                    }, null, 8, ["modelValue", "value"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, _unref(firstColumnKey), {
                  item: item,
                  cell: getColumnValue(_unref(firstColumn), _unref(firstColumnKey), item)
                }, () => [
                  _createTextVNode(_toDisplayString(getColumnValue(_unref(firstColumn), _unref(firstColumnKey), item) ?? _unref(firstColumn).fallback), 1)
                ])
              ], 14, _hoisted_17))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})